import React from 'react'
import * as UI from 'ui'
import { WhenModelValue } from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'

export default function ChecklistStreakTitle () {
  return (
    <div className='flex space-x-4 justify-between items-center'>
      <WhenModelValue name='badge.badge'>
        <UI.ShiftBadge name='badge.badge' big />
      </WhenModelValue>
      <UI.Text block>
        <Displays.Text name='streak' /> <Translation name='smartviews.checklists.streak' />
      </UI.Text>
    </div>
  )
}
